<script setup lang="ts">
const route = useRoute()
const { locale }  = useI18n()

// Education page
const { data, error } = await useAsyncData<EducationPage>(
  () => `education-page-${locale.value}`,
  () => $fetch<EducationPage>('/api/payload-gql', {
    method: 'POST',
    body: {
      query: GlobalEducationPageQuery,
      variables: { locale: locale.value },
    },
  })
)

if (error.value) {
  throw createError({
    statusCode: 500,
    statusMessage: `Error fetching page`,
  })
}

// Education entries
export interface EducationData extends payloadData {
  docs: Education[]
}

const { data: entries, error: entriesError } = await useAsyncData<EducationData>(
  () => `education-entries-${locale.value}`,
  () => $fetch<EducationData>('/api/payload-gql', {
    method: 'POST',
    body: {
      query: ManyEducationQuery(),
      variables: {
        page: 1,
        limit: 100,
        locale: locale.value,
      },
    },
  })
)

// Head
useHead({
  title: data?.value?.title,
})

useSeoMeta({
  title: `${data?.value?.title} – Manifesta 16 Ruhr`,
  ogTitle: `${data?.value?.title} – Manifesta 16 Ruhr`,
})
</script>

<template>
  <div>
    <pages-education
      :data="data"
      :entries="entries?.docs"
    />

    <nuxt-page />
  </div>
</template>
